module.exports = __webpack_public_path__ + "/images/mockup_lista_general_EN.addff20.png";